export default "__VITE_ASSET__064a0e5a__"